module.exports = __webpack_public_path__ + "media/logo-video.47c851a1.mp4";